import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import { Modal, Button, Table, Card, Dropdown, Form, Col, Row } from 'react-bootstrap';
import { FaPlus, FaTrashAlt, FaEdit, FaSearch, FaBoxOpen, FaEye } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { useNavigate } from 'react-router-dom';
import '../Customize_Css/ViewProducts.css'

const ViewProducts = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showViewMoreModal, setShowViewMoreModal] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [editForm, setEditForm] = useState({
    productName: '',
    productType: '',
    categoryName: '',
    measurement: '',
    aboutTheProduct: '',
    benefits: '',
    storageAndUse: '',
    date: '',
    TodaysDeals: false,
    FastMoving: false,
    NewlyArrived: false,
    FrequantlyBroughtTogether: false,
    ExclusiveOffersForYou: false,
    comments: '',
  });
  const [errors, setErrors] = useState({});
  const [validFields, setValidFields] = useState({});

  // Fetch Products
  useEffect(() => {
    fetchAllProducts();
    fetchVendors();
  }, [epicxTenantId]);

  const fetchProducts = async (vendorName) => {
    if (!vendorName) {
      await fetchAllProducts();
      return;
    }
    try {
      const url = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/stock/productVendor?productVendorName=${encodeURIComponent(vendorName)}`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${AuthorizationToken}` }
      });
      setData(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      setData([]);
    }
  };

  const fetchAllProducts = async () => {
    try {
      const allProductsUrl = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/all`;
      const allProductsResponse = await axios.get(allProductsUrl, {
        headers: { Authorization: `Bearer ${AuthorizationToken}` }
      });
      setData(allProductsResponse.data);
    } catch (error) {
      console.error('Error fetching all products:', error);
      toast.error(`Error fetching all products: ${error.message}`);
    }
  };

  const fetchVendors = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/vendor/api/vendor/${epicxTenantId}`, {
        headers: { Authorization: `Bearer ${AuthorizationToken}` }
      });
      setVendors(response.data.vendors);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const handleVendorChange = (event) => {
    const vendorName = event.target.value;
    setSelectedVendor(vendorName);
    setCurrentPage(1);
    fetchProducts(vendorName);
  };

  const handleSearch = (value) => {
    setSearchTerm(value.toLowerCase());
    setCurrentPage(1);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const filteredData = data.filter((item) =>
    Object.keys(item).some((key) => {
      const value = item[key];
      return value !== null && value !== undefined && value.toString().toLowerCase().includes(searchTerm);
    })
  );

  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const handleViewMore = (product) => {
    setSelectedProduct(product);
    setShowViewMoreModal(true);
  };

  const handleCloseViewMoreModal = () => {
    setShowViewMoreModal(false);
    setSelectedProduct(null);
  };

  // Validation Logic
  const validateField = (id, value) => {
    const isEmpty = (val) => !val || val.toString().trim() === '';
    const validationRules = {
      productName: { message: 'Product Name is required', validator: (val) => !isEmpty(val) },
      categoryName: { message: 'Category Name is required', validator: (val) => !isEmpty(val) },
      measurement: { message: 'Measurement is required', validator: (val) => !isEmpty(val) },
      aboutTheProduct: { message: 'About the Product is required', validator: (val) => !isEmpty(val) },
      benefits: { message: 'Benefits are required', validator: (val) => !isEmpty(val) },
      storageAndUse: { message: 'Storage and Use details are required', validator: (val) => !isEmpty(val) },
      productType: { message: 'Product Type is required', validator: (val) => !isEmpty(val) },
      checkboxes: {
        message: 'At least one checkbox (Todays Deals, Fast Moving, Newly Arrived) must be selected',
        validator: () => editForm.TodaysDeals || editForm.FastMoving || editForm.NewlyArrived,
      },
      comments: { message: 'Comments cannot be blank if provided', validator: (val) => !val || !isEmpty(val) },
    };

    const rule = validationRules[id];
    if (!rule) return true;

    const isValid = rule.validator(value);
    setErrors((prev) => ({
      ...prev,
      [id]: isValid ? '' : rule.message,
    }));
    setValidFields((prev) => ({
      ...prev,
      [id]: isValid,
    }));
    return isValid;
  };

  const validateProductDetailsForm = () => {
    const fieldsToValidate = [
      'productName',
      'categoryName',
      'measurement',
      'aboutTheProduct',
      'benefits',
      'storageAndUse',
      'productType',
      'checkboxes',
      'comments',
    ];

    let isValid = true;
    fieldsToValidate.forEach((id) => {
      const value = editForm[id];
      if (!validateField(id, value) && id !== 'checkboxes') {
        isValid = false;
      }
    });

    if (!validateField('checkboxes', null)) {
      isValid = false;
    }

    return isValid;
  };

  // Edit Modal Handling
  const handleCloseModal = () => {
    setShowModal(false);
    setErrors({});
    setValidFields({});
    setEditForm({
      productName: '',
      productType: '',
      categoryName: '',
      measurement: '',
      aboutTheProduct: '',
      benefits: '',
      storageAndUse: '',
      date: '',
      TodaysDeals: false,
      FastMoving: false,
      NewlyArrived: false,
      FrequantlyBroughtTogether: false,
      ExclusiveOffersForYou: false,
      comments: '',
    });
  };

  const handleSelectItem = (id) => {
    setSelectedItems((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((itemId) => itemId !== id)
        : [...prevSelected, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(currentData.map((item) => item._id));
    } else {
      setSelectedItems([]);
    }
  };

  const handleEditAction = () => {
    if (!selectedVendor) {
      toast.warn('Please select a vendor.');
      return;
    }
    if (selectedItems.length > 0 && selectedVendor) {
      const selectedProductId = selectedItems[0];
      const product = data.find((item) => item._id === selectedProductId);
      if (product) {
        setEditForm({
          productName: product.productName,
          productType: product.productType,
          categoryName: product.categoryName,
          measurement: product.measurement,
          aboutTheProduct: product.aboutTheProduct,
          benefits: product.benefits,
          storageAndUse: product.storageAndUse,
          date: product.date || '',
          TodaysDeals: product.TodaysDeals,
          FastMoving: product.FastMoving,
          NewlyArrived: product.NewlyArrived,
          FrequantlyBroughtTogether: product.FrequantlyBroughtTogether,
          ExclusiveOffersForYou: product.ExclusiveOffersForYou,
          comments: product.comments,
        });
        setShowModal(true);
      }
    } else {
      toast.warn('Please select a product to edit.');
    }
  };

  const handleUpdateProduct = async () => {
    if (!validateProductDetailsForm()) {
      toast.error('Please fill in all required fields correctly.');
      return;
    }
    try {
      const product = data.find((item) => item._id === selectedItems[0]);
      const response = await axios.put(
        `${BASE_URL}/products/api/productDetails/${epicxTenantId}/${encodeURIComponent(selectedVendor)}/${selectedItems[0]}/update`,
        {
          ...editForm,
          productVendorName: product?.productVendorName || selectedVendor,
        },
        {
          headers: { Authorization: `Bearer ${AuthorizationToken}` }
        }
      );
      toast.success('Product updated successfully');
      fetchProducts(selectedVendor);
      handleCloseModal();
    } catch (error) {
      console.error('Error updating product:', error);
      toast.error(error?.response?.data?.message || 'Failed to update product');
    }
  };

  const handleDeleteAction = () => {
    if (!selectedVendor) {
      toast.warn('Please select a vendor.');
      return;
    }
    if (selectedItems.length === 0) {
      toast.warn('Please select a product to delete.');
      return;
    }
    const product = data.find((item) => item._id === selectedItems[0]);
    setDeleteTarget(product || { _id: selectedItems[0], productName: 'this product', productVendorName: selectedVendor });
  };

  const confirmDeleteProduct = async () => {
    const selectedProductId = deleteTarget?._id;
    const vendorName = deleteTarget?.productVendorName || selectedVendor;
    const apiUrl = `${BASE_URL}/products/api/productDetails/${epicxTenantId}/${encodeURIComponent(vendorName)}/${selectedProductId}/delete`;
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${AuthorizationToken}`,
        },
      });
      if (response.ok) {
        toast.success('Product deleted successfully!');
        setSelectedItems([]);
        setDeleteTarget(null);
        fetchProducts(selectedVendor);
      } else {
        const result = await response.json();
        toast.error(`Error: ${result.message || 'An error occurred'}`);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      toast.error(`Error: ${error.message}`);
    }
  };

  return (
    <>
      <Sidebar />
      <div className="products-page">
        <header className="products-hero">
          <div>
            <p className="products-kicker">Inventory</p>
            <h1>Products List</h1>
            <p>Browse, find, and manage products across your vendors.</p>
          </div>
          <button
            className="products-primary-btn"
            onClick={() => navigate(`/Add-product`)}
          >
            <FaPlus /> Add Product
          </button>
        </header>

        <section className="products-toolbar" aria-label="Product filters">
          <div className="products-filter">
            <label htmlFor="vendorDropdown">Vendor</label>
            <select
              className="form-select"
              id="vendorDropdown"
              value={selectedVendor}
              onChange={handleVendorChange}
            >
              <option value="">All vendors</option>
              {vendors.map((vendor) => (
                <option key={vendor.id} value={vendor.vendorName}>
                  {vendor.vendorName}
                </option>
              ))}
            </select>
          </div>

          <div className="products-toolbar-actions">
            <div className="products-search">
              <FaSearch aria-hidden="true" />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search products..."
                  aria-label="Search products"
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                />
            </div>
            <Dropdown>
                <Dropdown.Toggle
                  className="products-action-btn"
                >
                  Actions
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleDeleteAction} disabled={selectedItems.length !== 1}>
                    <FaTrashAlt className="me-2" /> Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
          </div>
        </section>

        <Card className="products-card">
            <div className="products-card-head">
              <div>
                <h2>All Products</h2>
                <p>
                  {selectedVendor ? `Showing products from ${selectedVendor}` : 'Showing products from all vendors'}
                </p>
              </div>
              <span className="products-count">
                <FaBoxOpen aria-hidden="true" />
                {data.length} {data.length === 1 ? 'product' : 'products'}
              </span>
            </div>
            <Card.Body className="products-card-body">
              <Table responsive className="products-table">
                <thead>
                  <tr>
                    <th className="products-check-cell">
                      <input
                        className="products-checkbox"
                        type="checkbox"
                        aria-label="Select all products on this page"
                        onChange={handleSelectAll}
                        checked={selectedItems.length === currentData.length && currentData.length > 0}
                      />
                    </th>
                    <th>Product Name</th>
                    <th>Vendor</th>
                    <th>Product Type</th>
                    <th>Category</th>
                    <th>Measurement</th>
                    <th className="products-action-cell">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData.length > 0 ? (
                    currentData.map((item) => (
                      <tr key={item._id} className={selectedItems.includes(item._id) ? 'is-selected' : ''}>
                        <td className="products-check-cell">
                          <input
                            className="products-checkbox"
                            type="checkbox"
                            aria-label={`Select ${item.productName}`}
                            checked={selectedItems.includes(item._id)}
                            onChange={() => handleSelectItem(item._id)}
                          />
                        </td>
                        <td><span className="product-name">{item.productName}</span></td>
                        <td>{item.productVendorName}</td>
                        <td><span className="product-type-badge">{item.productType}</span></td>
                        <td><span className="product-category-badge">{item.categoryName}</span></td>
                        <td><span className="product-measurement">{item.measurement}</span></td>
                        <td className="products-action-cell">
                          <div className="vendors-action-group">
                            <button
                              type="button"
                              className="vendors-icon-btn vendors-icon-btn--view"
                              title="View details"
                              aria-label={`View ${item.productName}`}
                              onClick={() => handleViewMore(item)}
                            >
                              <FaEye aria-hidden="true" />
                            </button>
                            <button
                              type="button"
                              className="vendors-icon-btn vendors-icon-btn--edit"
                              title="Edit product"
                              aria-label={`Edit ${item.productName}`}
                              onClick={() => {
                                if (!selectedVendor) { toast.warn('Please select a vendor to edit.'); return; }
                                setSelectedItems([item._id]);
                                setEditForm({
                                  productName: item.productName,
                                  productType: item.productType,
                                  categoryName: item.categoryName,
                                  measurement: item.measurement,
                                  aboutTheProduct: item.aboutTheProduct,
                                  benefits: item.benefits,
                                  storageAndUse: item.storageAndUse,
                                  date: item.date || '',
                                  TodaysDeals: item.TodaysDeals,
                                  FastMoving: item.FastMoving,
                                  NewlyArrived: item.NewlyArrived,
                                  FrequantlyBroughtTogether: item.FrequantlyBroughtTogether,
                                  ExclusiveOffersForYou: item.ExclusiveOffersForYou,
                                  comments: item.comments,
                                });
                                setShowModal(true);
                              }}
                            >
                              <FaEdit aria-hidden="true" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <div className="products-empty">
                          <span><FaBoxOpen aria-hidden="true" /></span>
                          <h3>No products found</h3>
                          <p>
                            {selectedVendor
                              ? 'Try another vendor or adjust your search.'
                              : 'No products match your current search.'}
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Card.Body>
            <div className="products-card-footer">
                <span className="products-page-summary">
                  {filteredData.length > 0
                    ? `Showing ${indexOfFirstItem + 1}–${Math.min(indexOfLastItem, filteredData.length)} of ${filteredData.length}`
                    : 'Showing 0 products'}
                </span>
                <div className="products-pagination">
                  <nav>
                    <ul className="pagination mb-0" aria-label="Products pagination">
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link btn-sm"
                          onClick={() => setCurrentPage(1)}
                          aria-label="First page"
                        >
                          «
                        </button>
                      </li>
                      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button
                          className="page-link btn-sm"
                          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                          aria-label="Previous page"
                        >
                        &lt;
                        </button>
                      </li>
                      <li className="page-item active">
                        <button
                          className="page-link btn-sm"
                          aria-current="page"
                        >
                          {currentPage}
                        </button>
                      </li>
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link btn-sm"
                          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                          aria-label="Next page"
                        >
                          &gt;
                        </button>
                      </li>
                      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                        <button
                          className="page-link btn-sm"
                          onClick={() => setCurrentPage(totalPages)}
                          aria-label="Last page"
                        >
                          »
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
            </div>
          </Card>

         <div className="products-footer">
          <Footer />
        </div>

        {/* View More Modal */}
        <Modal show={showViewMoreModal} onHide={handleCloseViewMoreModal} size="lg" dialogClassName="product-details-modal">
          <Modal.Header closeButton>
            <Modal.Title>Product Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedProduct && (
              <div className="product-details-content">
                <div className="product-details-title">
                  <span><FaBoxOpen aria-hidden="true" /></span>
                  <div>
                    <small>Product</small>
                    <h3>{selectedProduct.productName}</h3>
                  </div>
                </div>
                <div className="product-details-grid">
                  <div><span>Product Type</span><strong>{selectedProduct.productType || '—'}</strong></div>
                  <div><span>Category</span><strong>{selectedProduct.categoryName || '—'}</strong></div>
                  <div><span>Measurement</span><strong>{selectedProduct.measurement || '—'}</strong></div>
                  <div className="details-wide"><span>About the Product</span><p>{selectedProduct.aboutTheProduct || '—'}</p></div>
                  <div className="details-wide"><span>Benefits</span><p>{selectedProduct.benefits || '—'}</p></div>
                  <div className="details-wide"><span>Storage and Use</span><p>{selectedProduct.storageAndUse || '—'}</p></div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button className="products-modal-close" onClick={handleCloseViewMoreModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Product Modal */}
        <Modal show={showModal} onHide={handleCloseModal} size="xl" dialogClassName="product-edit-modal">
          <Modal.Header closeButton className="product-edit-header">
            <Modal.Title>
              <span className="product-edit-title-icon"><FaEdit aria-hidden="true" /></span>
              <span>
                <small>Inventory</small>
                Edit Product
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="product-edit-body">
            <div className="product-edit-content">
              <div className="product-edit-section-heading">
                <h5>Product Information</h5>
                <p>Review and update the product details below.</p>
              </div>
                <Form className="product-edit-form">
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Product Name <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          value={editForm.productName}
                          onChange={(e) => {
                            setEditForm({ ...editForm, productName: e.target.value });
                            validateField('productName', e.target.value);
                          }}
                          className={`bg-light ${errors.productName ? 'is-invalid' : validFields.productName ? 'is-valid' : ''}`}
                          readOnly
                        />
                        {errors.productName && <small className="text-danger">{errors.productName}</small>}
                      </Form.Group>
                    </Col>
                    {/* <Col md={4}>
                      <Form.Group>
                        <Form.Label>Product Type <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Select
                          value={editForm.productType}
                          onChange={(e) => {
                            setEditForm({ ...editForm, productType: e.target.value });
                            validateField('productType', e.target.value);
                          }}
                          className={`bg-light ${errors.productType ? 'is-invalid' : validFields.productType ? 'is-valid' : ''}`}
                        >
                          <option value="">Select Product Type</option>
                          <option value="Perishable">Perishable</option>
                          <option value="Non-Perishable">Non-Perishable</option>
                        </Form.Select>
                        {errors.productType && <small className="text-danger">{errors.productType}</small>}
                      </Form.Group>
                    </Col> */}
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Category <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          type="text"
                          value={editForm.categoryName}
                          onChange={(e) => {
                            setEditForm({ ...editForm, categoryName: e.target.value });
                            validateField('categoryName', e.target.value);
                          }}
                          className={`bg-light ${errors.categoryName ? 'is-invalid' : validFields.categoryName ? 'is-valid' : ''}`}
                          readOnly
                        />
                        {errors.categoryName && <small className="text-danger">{errors.categoryName}</small>}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Measurement <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Select
                          value={editForm.measurement}
                          onChange={(e) => {
                            setEditForm({ ...editForm, measurement: e.target.value });
                            validateField('measurement', e.target.value);
                          }}
                          className={`bg-light ${errors.measurement ? 'is-invalid' : validFields.measurement ? 'is-valid' : ''}`}
                        >
                          <option value="">Select Unit</option>
                          <option value="KG">KG</option>
                          <option value="Litre">Litre</option>
                          <option value="Piece">Piece</option>
                        </Form.Select>
                        {errors.measurement && <small className="text-danger">{errors.measurement}</small>}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>About the Product <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={editForm.aboutTheProduct}
                          onChange={(e) => {
                            setEditForm({ ...editForm, aboutTheProduct: e.target.value });
                            validateField('aboutTheProduct', e.target.value);
                          }}
                          className={`bg-light ${errors.aboutTheProduct ? 'is-invalid' : validFields.aboutTheProduct ? 'is-valid' : ''}`}
                        />
                        {errors.aboutTheProduct && <small className="text-danger">{errors.aboutTheProduct}</small>}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Benefits <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={editForm.benefits}
                          onChange={(e) => {
                            setEditForm({ ...editForm, benefits: e.target.value });
                            validateField('benefits', e.target.value);
                          }}
                          className={`bg-light ${errors.benefits ? 'is-invalid' : validFields.benefits ? 'is-valid' : ''}`}
                        />
                        {errors.benefits && <small className="text-danger">{errors.benefits}</small>}
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Storage and Use <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          value={editForm.storageAndUse}
                          onChange={(e) => {
                            setEditForm({ ...editForm, storageAndUse: e.target.value });
                            validateField('storageAndUse', e.target.value);
                          }}
                          className={`bg-light ${errors.storageAndUse ? 'is-invalid' : validFields.storageAndUse ? 'is-valid' : ''}`}
                        />
                        {errors.storageAndUse && <small className="text-danger">{errors.storageAndUse}</small>}
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3 product-feature-section">
                    <div className="product-feature-heading">
                      <h6>Product Visibility</h6>
                      <p>Choose where this product should be featured. <span className="edit-required">*</span></p>
                    </div>
                    <Col md={2}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Today's Deals"
                          checked={editForm.TodaysDeals}
                          onChange={(e) => {
                            setEditForm({ ...editForm, TodaysDeals: e.target.checked });
                            validateField('checkboxes', null);
                          }}
                          className="customs-checkbox"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Fast Moving"
                          checked={editForm.FastMoving}
                          onChange={(e) => {
                            setEditForm({ ...editForm, FastMoving: e.target.checked });
                            validateField('checkboxes', null);
                          }}
                          className="customs-checkbox"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Newly Arrived"
                          checked={editForm.NewlyArrived}
                          onChange={(e) => {
                            setEditForm({ ...editForm, NewlyArrived: e.target.checked });
                            validateField('checkboxes', null);
                          }}
                          className="customs-checkbox"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Frequently Brought Together"
                          checked={editForm.FrequantlyBroughtTogether}
                          onChange={(e) => setEditForm({ ...editForm, FrequantlyBroughtTogether: e.target.checked })}
                          className="customs-checkbox"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group>
                        <Form.Check
                          type="checkbox"
                          label="Exclusive Offers For You"
                          checked={editForm.ExclusiveOffersForYou}
                          onChange={(e) => setEditForm({ ...editForm, ExclusiveOffersForYou: e.target.checked })}
                          className="customs-checkbox"
                        />
                      </Form.Group>
                    </Col>
                    {errors.checkboxes && (
                      <Col md={12}>
                        <small className="text-danger">{errors.checkboxes}</small>
                      </Col>
                    )}
                  </Row>

                  <Row className="product-comments-section">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Comments</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={2}
                          placeholder="Enter any comments or notes"
                          value={editForm.comments}
                          onChange={(e) => {
                            setEditForm({ ...editForm, comments: e.target.value });
                            validateField('comments', e.target.value);
                          }}
                          className={`bg-light ${errors.comments ? 'is-invalid' : validFields.comments ? 'is-valid' : ''}`}
                        />
                        {errors.comments && <small className="text-danger">{errors.comments}</small>}
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
            </div>
          </Modal.Body>
          <Modal.Footer className="product-edit-footer">
            <Button
              onClick={handleCloseModal}
              className="product-edit-cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdateProduct}
              className="product-edit-save"
            >
              Update Product
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={Boolean(deleteTarget)}
          onHide={() => setDeleteTarget(null)}
          centered
          dialogClassName="list-confirm-dialog"
          contentClassName="list-confirm-modal"
        >
          <Modal.Body className="list-confirm-body">
            <div className="list-confirm-icon" aria-hidden="true">
              <FaTrashAlt />
            </div>
            <h3>Delete this product?</h3>
            <p>
              <strong>{deleteTarget?.productName}</strong> will be removed from the products list for <strong>{deleteTarget?.productVendorName || selectedVendor}</strong>.
            </p>
          </Modal.Body>
          <Modal.Footer className="list-confirm-footer">
            <Button className="list-confirm-cancel" onClick={() => setDeleteTarget(null)}>
              Cancel
            </Button>
            <Button className="list-confirm-delete" onClick={confirmDeleteProduct}>
              Yes, delete
            </Button>
          </Modal.Footer>
        </Modal>

       
      </div>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
      />
    </>
  );
};

export default ViewProducts;